require("layout/top_bar_warning.scss");

var TopBarWarning = function(props) {
	if ($wr.isInternetExplorer()) {
		var ieWarning = (
			<div className="ieWarning">
				<strong>We noticed you're using Internet Explorer.</strong> Some parts of Whooo's Reading
				don't work on Internet Explorer. We recommend using either{" "}
				<a href="https://www.google.com/chrome/">Google Chrome</a> or{" "}
				<a href="https://www.mozilla.org/en-US/firefox/products/">Mozilla Firefox</a>.
			</div>
		);
	}

	return (
		<div className="topBarWarning">
			{ ieWarning }
		</div>
	);
}

TopBarWarning.propTypes = StrictPropTypes({
});

module.exports = TopBarWarning;



// WEBPACK FOOTER //
// ./modules/components/layout/TopBarWarning.js